import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import React from 'react';
import { useBreakpoints } from 'src/hooks/useBreakpoints';
import colors from 'src/styles/colors.module.scss';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import styles from './calloutGray.module.scss';
import Selectors from 'src/utils/selectors';

interface Props {
    heading: string;
    body: string | JSX.Element;
    button?: JSX.Element;
    icon?: JSX.Element;
    className?: string;
    'data-cy'?: string;
    textContainerClassOverrides?: string;
}

export default function CalloutGray({
    heading,
    body,
    button,
    icon,
    className,
    'data-cy': dataCy,
    textContainerClassOverrides
}: Props): JSX.Element {
    const { isMinWidthSmall } = useBreakpoints();

    return (
        <div className={`${styles.container} ${className}`} data-cy={dataCy}>
            <div className={styles.content}>
                {isMinWidthSmall && icon}
                <div className={`${styles.textContainer} ${textContainerClassOverrides}`}>
                    <Typography
                        className={styles.heading}
                        component="p"
                        variant={TypographyVariants.HEADING_XS}
                        data-cy={Selectors.SpendSmart.CALLOUT_HEADER}
                    >
                        {heading}
                    </Typography>
                    <p
                        className={`${DlsTypographyVariants.BODY_1} ${colors.gray06}`}
                        data-cy={Selectors.SpendSmart.CALLOUT_BODY}
                    >
                        {body}
                    </p>
                </div>
            </div>
            {button && <div className={styles.buttonContainer}>{button}</div>}
        </div>
    );
}
